import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Typography, FormControlLabel, Checkbox } from "@mui/material";
import { MaritalStatusValue, MaritalStatus } from "@quest_editor/constants";

const MaritalStatusField = ({
  maritalStatus,
  setMaritalStatus,
}: {
  maritalStatus: MaritalStatusValue[];
  setMaritalStatus: React.Dispatch<React.SetStateAction<MaritalStatusValue[]>>;
}) => {
  const { t } = useTranslation("questEditor");

  const handleMaritalStatusChange =
    (key: MaritalStatusValue) =>
    (_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      setMaritalStatus((prev: MaritalStatusValue[]) =>
        checked
          ? prev.includes(key)
            ? prev
            : [...prev, key]
          : prev.filter((g) => g !== key),
      );
    };

  return (
    <Stack direction="row" alignItems="center">
      <FormControlLabel
        control={
          <Checkbox
            checked={maritalStatus.includes(MaritalStatus.SINGLE)}
            onChange={handleMaritalStatusChange(MaritalStatus.SINGLE)}
          />
        }
        label={t("common.marital_status.single")}
        sx={{ color: "text.secondary" }}
      />
      <FormControlLabel
        control={
          <Checkbox
            checked={maritalStatus.includes(MaritalStatus.MARRIED)}
            onChange={handleMaritalStatusChange(MaritalStatus.MARRIED)}
          />
        }
        label={t("common.marital_status.married")}
        sx={{ color: "text.secondary", ml: 2 }}
      />
      <Typography color="secondary" sx={{ ml: 4 }}>
        {t("quest_edit_target.label.not_specified.note_all_target")}
      </Typography>
    </Stack>
  );
};

export default MaritalStatusField;
